export default __webpack_public_path__ + "static/media/Bitfinex.aab5879d.png";